<template>
    <div>
        <Modal
            :show="modalVisibility"
            :overflowHidden="false"
            class="overflow-visible"
            @close="closeModal"
        >
            <div class="flex flex-col">
                <h1 class="text-body-2 mt-3 mb-2">Add folder</h1>
                <div class="xxs:p-4 bg-white rounded border border-white lg:px-0 lg:pt-4 lg:pb-0 box-border">
                    <div class="w-full mt-2">
                        <label class="text-body-6 font-medium mb-2">
                            Folder name
                        </label>
                    </div>
                    <div class="relative flex flex-row justify-between">
                        <input
                            v-model="folderName"
                            type="text"
                            class="block w-full xxs:h-12 lg:h-10 text-body-6 font-normal text-default-1 rounded border border-interactive-9 focus:outline-none focus:ring-0"
                            ref="folderNameRef"
                            @keyup.enter="add"
                        />
                    </div>

                    <Button
                        :disabled="isNameEmpty"
                        class="xxs:w-full lg:w-auto self-start mt-6"
                        variant="primary"
                        @click="add"
                        :loading="loading"
                    >Add</Button>

                </div>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import Modal from "@/components/core/Modal.vue";
import Button from "@/components/core/Button.vue";
import InputGroup from "@/components/core/InputGroup.vue";
import {computed, nextTick, onMounted, ref} from "vue";

const emit = defineEmits(['add-folder', 'close']);

const props = defineProps({
    modalVisibility: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    currentFolder: {
        type: [Object, null],
        default: null
    }
});

const folderNameRef = ref(null);
const folderName = ref('');

function add() {
    emit('add-folder', folderName.value);
    folderName.value = '';
}

function closeModal() {
    folderName.value = '';
    emit('close')
}

const isNameEmpty = computed(() => folderName.value === '');

onMounted(() => {
    nextTick(() => {
        folderNameRef.value.focus();
    });
})
</script>

<style src="../../../../node_modules/@vueform/multiselect/themes/default.css"></style>

<style lang="scss">
.multiselect {
    border-color: #EFF2F7;

    &.is-active {
        border: 1px solid #556EE6;
        box-shadow: none;
    }

    &.is-disabled {
        background: white;

        .multiselect-caret {
            display: none;
        }
    }
}

.multiselect-dropdown {
    max-height: 400px;
}

.multiselect-caret, .multiselect-clear-icon {
    z-index: 1;
}

.white-inset {
    -webkit-box-shadow: inset 0 0 0 10px #FFFFFF;
    box-shadow: inset 0 0 0 10px #FFFFFF;
}

.multiselect-inifite-spinner, .multiselect-spinner {
    background-color: var(--primary-color);
}
</style>